<template>
    <div>
        <div class="content-gridless" v-if="this.currentGroupName == ''">
            <div class="container ">
                <div class="row align-items-center fill">
                    <div class="col align-self-center">
                        <div class="card card-block p-1">
                            <h1 class="m-1 text-center text-muted">
                                <br> Bitte im Menü eine Gruppe auswählen <br> <br>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.currentGroupName != ''" class="container-fluid p-4">
            <!-- Main Group Settings Card -->
            <div class="card mb-4 shadow-sm">
                <div class="card-body">
                    <h2 class="mb-4">Bearbeite Gruppe: <strong>{{ this.currentGroupName }}</strong></h2>
                    
                    <form>
                        <!-- Group Name -->
                        <div class="form-group mb-4">
                            <label for="newGroupName" class="font-weight-bold">Neuer Gruppenname</label>
                            <input
                                v-model="t_newGroupName"
                                type="text"
                                class="form-control"
                                id="newGroupName"
                                placeholder="Gruppenname"
                                title="Eindeutige Bezeichnung der Gruppe"
                                @keydown.enter.prevent
                            >
                        </div>

                        <!-- File Upload Areas Side by Side -->
                        <div class="row mb-4">
                            <div class="col-md-6">
                                <label for="cashOrderFile" class="font-weight-bold">Kassenanordnungsvorlage</label>
                                <div
                                    class="drop-area"
                                    @drop.prevent="handleFileDropCashOrder"
                                    @dragover.prevent
                                    @click="$refs.cashOrderFile.click()"
                                >
                                    <input
                                        type="file"
                                        id="cashOrderFile"
                                        ref="cashOrderFile"
                                        v-on:change="t_cashOrderFile = $refs.cashOrderFile.files[0]"
                                        style="display: none;"
                                    />
                                    <p v-if="t_cashOrderFile === null">Ziehe die ODT-Vorlage hier rein</p>
                                    <p v-else>{{ t_cashOrderFile.name }}</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="countingProtocolFile" class="font-weight-bold">Zählprotokollvorlage</label>
                                <div
                                    class="drop-area"
                                    @drop.prevent="handleFileDropCountingProtocol"
                                    @dragover.prevent
                                    @click="$refs.countingProtocolFile.click()"
                                >
                                    <input
                                        class="form-control-file"
                                        type="file" 
                                        id="countingProtocolFile" 
                                        ref="countingProtocolFile"
                                        v-on:change="t_countingProtocolFile = $refs.countingProtocolFile.files[0]"
                                        style="display: none;"
                                    />
                                    <p v-if="t_countingProtocolFile === null">Ziehe die ODS-Vorlage hier rein</p>
                                    <p v-else>{{ t_countingProtocolFile.name }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- Category Required Toggle Section -->
                        <div class="mb-4 pb-3">
                            <div class="d-flex align-items-center mb-2">
                                <input
                                    v-model="localTransactionCategoryRequired"
                                    type="checkbox"
                                    class="mr-3"
                                    id="transactionCategoryRequired"
                                    style="width: 20px; height: 20px;"
                                >
                                <label class="mb-0 font-weight-bold" for="transactionCategoryRequired">
                                    Kategorie bei Buchung erforderlich
                                </label>
                            </div>
                            <small class="text-muted">Änderung wird erst nach "Gruppe speichern" wirksam.</small>
                        </div>

                        <!-- Action Buttons -->
                        <div class="d-flex justify-content-end">
                            <button 
                                type="button"
                                v-on:click="perform('DELETE')" 
                                class="btn btn-danger mr-2"
                            >
                                Gruppe löschen
                            </button>
                            <button 
                                type="button"
                                v-on:click="perform('SAVE')" 
                                class="btn btn-success"
                            >
                                Gruppe speichern
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Category Editor Card -->
            <div class="card shadow-sm">
                <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                        <h3 class="mb-0 mr-3">Buchungskategorien</h3>
                    </div>
                    <p class="text-muted mb-4">Hinzufügen/Löschen wird sofort gespeichert.</p>
                    <CategoryEditor
                        :current_group_id="this.$store.state.current_group.id"
                    ></CategoryEditor>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CategoryEditor from './CategoryEditor.vue';

export default {
    name: 'EditGroup',
    components: {
        CategoryEditor
    },
    data() {
        return {
            error_msg: 'No Error',
            t_newGroupName: '',
            t_cashOrderFile: null,
            t_countingProtocolFile: null,
            localTransactionCategoryRequired: false,
        }
    },
    mounted() {
        // Initialize the checkbox value when component mounts
        if (this.$store.state.current_group && this.$store.state.current_group.transactionCategoryRequired !== undefined) {
            this.localTransactionCategoryRequired = this.$store.state.current_group.transactionCategoryRequired;
        }
    },
    methods: {
        handleFileDropCashOrder(event) {
            this.t_cashOrderFile = event.dataTransfer.files[0];
            console.log(this.t_cashOrderFile);
            this.$refs.cashOrderFile.files = event.dataTransfer.files;
        },
        handleFileDropCountingProtocol(event) {
            this.t_countingProtocolFile = event.dataTransfer.files[0];
            this.$refs.countingProtocolFile.files = event.dataTransfer.files;
        },
        perform(actionType) {
            if (actionType === "SAVE") {
                if (!confirm('Gruppe speichern?')) {
                    return;
                }
                const data = new FormData();
                data.append('newGroupName', this.t_newGroupName)
                console.log("New group name");
                console.log(this.t_newGroupName);
                data.append('transactionCategoryRequired', this.localTransactionCategoryRequired)
                if (this.t_cashOrderFile !== null) {
                    data.append('cashOrderFile', this.t_cashOrderFile)
                }
                if (this.t_countingProtocolFile !== null) {
                    data.append('countingProtocolFile', this.t_countingProtocolFile)
                }
                let credentials = JSON.parse(localStorage.getItem('credentials'))

                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/groups/' + this.currentGroupName,
                    data: data,
                    auth: credentials,
                    method: 'put'
                }).catch(e => {
                    console.log(e);
                }).then(resp => {
                    this.$store.dispatch('loadGroupData')
                    let msg = resp.data
                    console.log("Message")
                    console.log(msg)
                    if (msg !== null) {
                        console.log("Pushing error")
                        this.$store.commit('add_message', msg)
                        if (msg.type !== "ERROR") {
                            this.t_newGroupName = '';
                        }
                    }
                });
            }
            if (actionType === "DELETE") {
                if (!confirm('Gruppe löschen?')) {
                    return;
                }
                console.log("DELETE group");

                const data = new FormData();
                let credentials = JSON.parse(localStorage.getItem('credentials'))

                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/groups/' + this.currentGroupName,
                    data: data,
                    auth: credentials,
                    method: 'delete'
                }).catch(e => {
                    console.log(e);
                }).then(resp => {
                    this.$store.dispatch('loadGroupData')
                    let msg = resp.data
                    console.log("Message: ")
                    console.log(msg)
                    if (msg !== null) {
                        this.$store.commit('add_message', msg);
                        if (msg.type !== "ERROR") {
                            this.$store.commit('switch_group', null)
                        }
                    }
                });

            }
            this.t_newGroupName = ''
            this.t_cashOrderFile = null
            this.t_countingProtocolFile = null
            this.$refs.cashOrderFile.value = null
            this.$refs.countingProtocolFile.value = null
        }
    },
    watch: {
        '$store.state.current_group': {
            handler(newGroup) {
                if (newGroup && newGroup.transactionCategoryRequired !== undefined) {
                    this.localTransactionCategoryRequired = newGroup.transactionCategoryRequired;
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        accountName() {
            return this.$store.state.current_acc
        },
        currentGroupName() {
            if (this.$store.state.current_group === null) {
                return ""
            }
            return this.$store.state.current_group.name
        },
    }
}
</script>

<style scoped>
    .card {
        border-radius: 8px;
        border: 1px solid #e0e0e0;
    }

    .card-body {
        padding: 2rem;
    }

    .drop-area {
        border: 2px dashed #ccc;
        border-radius: 6px;
        padding: 60px 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #fafafa;
    }

    .drop-area:hover {
        border-color: #888;
        background-color: #f5f5f5;
    }

    .drop-area p {
        margin: 0;
        font-size: 14px;
        color: #666;
    }

    .shadow-sm {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
    }

    .badge-success {
        background-color: #28a745;
        font-weight: normal;
        padding: 0.4em 0.8em;
        font-size: 0.85rem;
    }

    .font-weight-bold {
        font-weight: 600;
    }

    h2 {
        font-size: 1.75rem;
        font-weight: 600;
    }

    h3 {
        font-size: 1.5rem;
        font-weight: 600;
    }
</style>

